import { useState } from "react";
import { getSummary } from "./transcribeApi";
import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";

const useSummary = () => {
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);
  const [summary, setSummary] = useState(null);

  const sendSummaryRequest = async (transcript) => {
    setIsSummaryLoading(true);
    getSummary(transcript)
      .then((response) => {
        setSummary(response.data);
      })
      .catch((error) => {
        notify({
          type: TYPE.error,
          content: error?.response?.data?.message,
          duration: DURATION.INFINITE,
        });
        setSummary(null);
      })
      .finally(() => setIsSummaryLoading(false));
  };

  return { summary, isSummaryLoading, setSummary, sendSummaryRequest };
};

export default useSummary;
